import React from 'react';
import { Box, Tab, Tabs, Grid, useMediaQuery, useTheme, Typography, Portal } from '@mui/material';
import getTabStyle from './styles/style';
import Chip from '@mui/material/Chip';
import { COLOR_PRIMARY_2 } from 'src/colors';
import { COLOR_PRIMARY } from 'src/const';

const TabBar = ({
  tabList,
  selectedCurrentTab,
  color,
  renderLabelCondition,
  actionButton,
  showActionButton,
  transparentBackground,
  isMobile,
  scrollButtons,
  hideTabs,
  hideOption,
  extraStyling,
  size,
}: {
  tabList;
  selectedCurrentTab;
  color;
  renderLabelCondition;
  actionButton;
  showActionButton?;
  transparentBackground?: boolean;
  isMobile?: boolean;
  scrollButtons?: boolean;
  hideTabs?: boolean;
  hideOption?: string;
  extraStyling?: any;
  size?: string;
}) => {
  const renderLabel = renderLabelCondition();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down(900));
  let styles = getTabStyle(color, transparentBackground ? transparentBackground : false);

  return (
    <Box
      sx={{
        ...styles.root,
        ...(extraStyling ? extraStyling : {}),
      }}
    >
      <Grid
        container
        direction="row"
        justifyContent={hideTabs ? 'flex-end' : matches ? 'center' : 'space-between'}
        alignItems="center"
        item
        xs={12}
      >
        {!hideTabs && (
          <Tabs
            value={selectedCurrentTab}
            sx={{
              ...styles.tabs,
              ...(size === 'small'
                ? {
                    minHeight: '34px',
                    height: '34px',
                  }
                : {}),
            }}
            variant="scrollable"
            scrollButtons={scrollButtons ? true : false}
          >
            {tabList
              .filter(currentTab => currentTab.value !== (hideOption ? hideOption : ''))
              .map((currentTab, index) => {
                return (
                  <Tab
                    key={index + '-tab-bar'}
                    className={'tab-bar-tab'}
                    icon={
                      currentTab.beta && selectedCurrentTab === currentTab.value ? (
                        <Box display="flex" alignItems="center">
                          {currentTab.icon}
                          <Portal
                            container={() => document.querySelectorAll('.tab-bar-tab')[index]}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                display: 'block',
                                ml: '5px',
                                color: COLOR_PRIMARY,
                                border: '1px solid ' + COLOR_PRIMARY,
                                borderRadius: '100px',
                                pointerEvents: 'none',
                                p: '0 10px !important',
                                ...(isMobile
                                  ? {
                                      fontSize: '10px',
                                      top: '-10px',
                                      zIndex: 99999,
                                    }
                                  : {}),
                              }}
                            >
                              Beta
                            </Typography>
                          </Portal>
                        </Box>
                      ) : (
                        currentTab.icon
                      )
                    }
                    label={<span>{renderLabel ? currentTab.label : ''}</span>}
                    value={currentTab.value}
                    iconPosition="start"
                    sx={{
                      ...styles.tab,
                      ...(size === 'small'
                        ? {
                            minHeight: '24px',
                            height: '24px',
                            minWidth: '70px',
                            padding: '4px 6px',
                            fontSize: '12px',
                            paddingLeft: '16px',
                            '& .MuiSvgIcon-root': {
                              fontSize: '16px',
                            },
                          }
                        : {}),
                    }}
                    onClick={currentTab.onclick}
                    wrapped
                  />
                );
              })}
          </Tabs>
        )}
        {showActionButton ? actionButton : <></>}
      </Grid>
    </Box>
  );
};

export default TabBar;
